import { render } from "./DemoDetail.vue?vue&type=template&id=4986ad2c&scoped=true&ts=true"
import script from "./DemoDetail.vue?vue&type=script&lang=ts"
export * from "./DemoDetail.vue?vue&type=script&lang=ts"

import "./DemoDetail.vue?vue&type=style&index=0&id=4986ad2c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4986ad2c"]])

export default __exports__